import { SuiteManifest } from '../manifest';
import { financeRoutes } from './routes';
import { financeNavItems } from './nav';

export const financeManifest: SuiteManifest = {
  id: 'finance',
  name: 'Finance & Invoicing',
  basePath: '/finance',
  icon: 'credit-card',
  description: 'Invoicing, billing, multi-currency accounting, and bank reconciliation.',
  requiredPermission: 'finance.invoice.read',
  nav: financeNavItems,
  routes: financeRoutes,
};

export default financeManifest;
